<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gUbO9U/tc-custom/9781328694447.jpg?1705635375880" alt="This image is the cover for the book Ready, Set. . . Baby!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ready, Set. . . Baby!
      </h1>
      <p class="bookDescription body article font2">
        <p><b>What kids can expect when they’re expecting siblings—full of solid information, kid-friendly humor, and even tips for parents.</b></p><p>In a fresh picture book/comic style, <i>Ready, Set…Baby </i>offers up a funny, loving, reassuring peek into life as a big brother or sister.</p><p>Anna and Oliver, big siblings extraordinaire, are here to tell you what to expect when your family is expecting—and what life will really be like once a new baby arrives. The dynamic duo covers everything from naptime to stinky diapers and from holding the baby to deciphering your baby’s body language. They even offer up helpful ideas for parents on how to make life as a big brother or sister as filled with fun—and love—as it can be!</p> So get ready…get set…it’s time to welcome a new baby!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Elizabeth Rusch, Qin Leng
      </h2>
      
      <p class="authorDescription body article">The award-winning freelance writer Elizabeth Rusch is the author of a number of award-winning nonfiction titles for children, including: Generation Fix, Will it Blow?,The Planet Hunter, and For the Love of Music: The Remarkable Story of Maria Anna Mozart. Her previous Scientists in the Field titles include Eruption!, The Mighty Mars Rovers and The Next Wave. Elizabeth lives in Portland, Oregon, with her family. You can visit Liz online at www.elizabethrusch.com and follow her on Twitter @elizabethrusch.Qin Leng was born in Shanghai, and lived in France and Montreal. She now lives and works as a designer and illustrator in Toronto. To learn more, visit qinleng.tumblr.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?914edf62